/*
 * Secret Gifters — PDF Rapportage generator (v7: netto na abonnement + terugverdientijd)
 *
 * A4-rapportage in de huisstijl van de site en het klantenportaal:
 *   - Witte pagina-achtergrond (#ffffff) voor een professionele uitstraling
 *   - Navy primair #1e3a5f, gold #98806b, cream #faf7f4
 *   - Pagina 1: titel, klantblok, inleiding, KPI's, basis-lijst, CTA
 *   - Pagina 2: "wat organisaties onderschatten" + jullie antwoorden
 *
 * Vereist:
 *   - jsPDF (al geladen door de calculator-sectie)
 *   - window.SG_CALC_STATE (vanuit calculator script gezet)
 */
(function () {
  'use strict';

  // === Huisstijl-kleuren (matcht site en portaal) ===
  var NAVY     = [30,  58,  95];   // #1e3a5f
  var TEXT     = [24,  31,  43];   // #181f2b
  var BODY     = [60,  60,  70];   // body tekst
  var CREAM    = [250, 247, 244];  // #faf7f4 zachte kaarten
  var BORDER   = [221, 213, 200];  // #ddd5c8
  var GOLD     = [152, 128, 107];  // #98806b
  var GOLD_LT  = [176, 152, 128];  // #b09880
  var MUTED    = [107, 101, 96];   // #6b6560
  var SUBTLE   = [160, 152, 144];  // #a09890
  var WHITE    = [255, 255, 255];

  // Guided-abonnement: tijdelijk €99 p/m, verlaagd 27 aug 2026.
  // Gaat van de bruto HR-besparing af (bron: Drive-sheet "Calculator",
  // tab "De Download versie 2.0"). Houd gelijk aan CFG in sg-calculator.liquid.
  var LICENSE_MONTH    = 99;
  var LICENSE_PER_YEAR = 1188;

  // === Labels uit de calculator ===
  var MOMENT_LABELS = {
    verjaardagen: 'Verjaardagen',
    jubilea:      'Jubilea',
    geboorte:     'Geboorte',
    beterschap:   'Ziekte / Beterschap',
    feestdagen:   'Feestdagen',
    nieuwe:       'Nieuwe medewerkers',
    bedank:       'Bedankmomenten',
    anders:       'Anders'
  };
  var CHALLENGE_LABELS = {
    binden:    'Medewerkers beter binden en behouden',
    adhoc:     'Waardering gebeurt te ad hoc',
    tijd:      'Het kost te veel tijd om zelf te regelen',
    origineel: 'Lastig origineel en persoonlijk te houden',
    werkgeluk: 'Werkgeluk en betrokkenheid verbeteren'
  };
  var ROLE_LABELS = {
    eigenaar:  'Eigenaar / Ondernemer',
    directeur: 'Directeur / Management',
    hr:        'HR',
    office:    'Office management',
    support:   'Management support / Secretaresse',
    marketing: 'Marketing manager',
    anders:    'Anders'
  };

  function fmtEUR(n) {
    return '€ ' + Math.round(n).toLocaleString('nl-NL');
  }

  // Zelfde rekenregels als calculateResults() in sg-calculator.liquid.
  function calculate(state) {
    var hoursNow = (60 * state.frequency * state.employees) / 60;
    var hoursSG  = (15 * state.frequency * state.employees) / 60;
    var gross    = Math.max(0, Math.round((hoursNow - hoursSG) * state.hrRate));
    var netRaw   = gross - LICENSE_PER_YEAR;
    return {
      gross:         gross,
      license:       LICENSE_PER_YEAR,
      net:           Math.max(0, netRaw),
      netRaw:        netRaw,
      paybackMonths: (netRaw > 0 && (LICENSE_PER_YEAR / netRaw) * 12 <= 36) ? Math.max(1, Math.round((LICENSE_PER_YEAR / netRaw) * 12)) : null,
      hours:         Math.max(0, Math.round(hoursNow - hoursSG))
    };
  }

  function listMoments(state) {
    var items = (state.moments || []).map(function (id) {
      if (id === 'anders' && state.momentOther) return state.momentOther;
      return MOMENT_LABELS[id] || id;
    });
    return items.length ? items.join(', ') : 'Niet opgegeven';
  }
  function listChallenges(state) {
    var items = (state.challenges || []).map(function (id) {
      return CHALLENGE_LABELS[id] || id;
    });
    return items.length ? items.join(', ') : 'Niet opgegeven';
  }
  function showRole(state) {
    if (!state.role) return 'Niet opgegeven';
    if (state.role === 'anders' && state.roleOther) return state.roleOther;
    return ROLE_LABELS[state.role] || state.role;
  }

  // ============================================================
  // Helper — footer (uniform op beide pagina's)
  // ============================================================
  function drawFooter(doc, W, MARGIN, page, total) {
    var fy = 285;
    doc.setDrawColor(BORDER[0], BORDER[1], BORDER[2]);
    doc.setLineWidth(0.3);
    doc.line(MARGIN, fy - 5, W - MARGIN, fy - 5);

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(7.5);
    doc.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
    doc.text('SECRET GIFTERS', MARGIN, fy);

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(7.5);
    doc.setTextColor(BODY[0], BODY[1], BODY[2]);
    doc.text('www.secretgifters.nl', W / 2, fy, { align: 'center' });

    doc.setFont('helvetica', 'italic');
    doc.setFontSize(7);
    doc.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
    var label = 'Indicatieve berekening — geen offerte';
    if (total > 1) label = 'Pagina ' + page + ' van ' + total + ' — ' + label;
    doc.text(label, W - MARGIN, fy, { align: 'right' });
  }

  // ============================================================
  // PDF render
  // ============================================================
  function buildPDF(state, save) {
    var jsPDFCtor = (window.jspdf && window.jspdf.jsPDF) || window.jsPDF;
    if (!jsPDFCtor) {
      if (save) alert('PDF-bibliotheek niet geladen — vernieuw de pagina en probeer opnieuw.');
      return null;
    }

    var r = calculate(state);
    var doc = new jsPDFCtor({ unit: 'mm', format: 'a4', orientation: 'portrait' });
    var W = 210, H = 297, MARGIN = 16;
    var CW = W - 2 * MARGIN;

    // ============================================================
    // PAGINA 1 — Samenvatting
    // ============================================================
    doc.setFillColor(WHITE[0], WHITE[1], WHITE[2]);
    doc.rect(0, 0, W, H, 'F');

    // ---- Header (navy strip) ----
    var headerH = 26;
    doc.setFillColor(NAVY[0], NAVY[1], NAVY[2]);
    doc.rect(0, 0, W, headerH, 'F');

    doc.setTextColor(GOLD_LT[0], GOLD_LT[1], GOLD_LT[2]);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(8);
    doc.text('SECRET GIFTERS', MARGIN, 11);

    doc.setTextColor(WHITE[0], WHITE[1], WHITE[2]);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8.5);
    doc.text('Rapportage waarderingsmomenten', MARGIN, 17.5);

    var today = new Date().toLocaleDateString('nl-NL', { day: 'numeric', month: 'long', year: 'numeric' });
    doc.setTextColor(GOLD_LT[0], GOLD_LT[1], GOLD_LT[2]);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(7);
    doc.text('DATUM', W - MARGIN, 11, { align: 'right' });

    doc.setTextColor(WHITE[0], WHITE[1], WHITE[2]);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    doc.text(today, W - MARGIN, 17.5, { align: 'right' });

    // Gold hairline onder header
    doc.setFillColor(GOLD[0], GOLD[1], GOLD[2]);
    doc.rect(0, headerH, W, 0.5, 'F');

    // ---- Hoofdtitel + subtitel ----
    var y = 38;
    doc.setTextColor(NAVY[0], NAVY[1], NAVY[2]);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(15);
    var titleLines = doc.splitTextToSize(
      'Wat kosten losse waarderingsmomenten jullie organisatie écht?',
      CW
    );
    doc.text(titleLines, MARGIN, y);
    y += titleLines.length * 6.5 + 1;

    doc.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9.5);
    var subLines = doc.splitTextToSize(
      'Indicatieve berekening op basis van jullie antwoorden en gemiddelde HR-processen.',
      CW
    );
    doc.text(subLines, MARGIN, y + 1);
    y += subLines.length * 4.5 + 4;

    doc.setDrawColor(BORDER[0], BORDER[1], BORDER[2]);
    doc.setLineWidth(0.3);
    doc.line(MARGIN, y, W - MARGIN, y);
    y += 6;

    // ---- Klantblok (Voor — naam + bedrijfsnaam prominent) ----
    var fullName = ((state.contact.firstName || '') + ' ' + (state.contact.lastName || '')).trim();
    var company  = (state.contact.company || '').trim();

    doc.setTextColor(GOLD[0], GOLD[1], GOLD[2]);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(7.5);
    doc.text('VOOR', MARGIN, y);

    var rightLabelX = MARGIN + 70;
    if (company) {
      doc.setTextColor(GOLD[0], GOLD[1], GOLD[2]);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(7.5);
      doc.text('BEDRIJF', rightLabelX, y);
    }

    doc.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(12);
    doc.text(fullName || '—', MARGIN, y + 6);

    if (company) {
      doc.setTextColor(NAVY[0], NAVY[1], NAVY[2]);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(12);
      doc.text(company, rightLabelX, y + 6);
    }

    // Subline met email/telefoon
    var subParts = [];
    if (state.contact.email)   subParts.push(state.contact.email);
    if (state.contact.phone)   subParts.push(state.contact.phone);
    if (subParts.length) {
      doc.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(8.5);
      doc.text(subParts.join('   ·   '), MARGIN, y + 11);
      y += 15;
    } else {
      y += 11;
    }

    doc.setDrawColor(BORDER[0], BORDER[1], BORDER[2]);
    doc.setLineWidth(0.3);
    doc.line(MARGIN, y, W - MARGIN, y);
    y += 6;

    // ---- Inleidende paragraaf ----
    doc.setTextColor(BODY[0], BODY[1], BODY[2]);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9.5);
    var introLines = doc.splitTextToSize(
      'Op basis van jullie antwoorden lijkt waardering binnen jullie organisatie meer tijd en handmatig regelwerk te kosten dan vaak wordt gedacht. Vooral terugkerende momenten zoals verjaardagen, jubilea en feestdagen zorgen ongemerkt voor extra HR-tijd.',
      CW
    );
    doc.text(introLines, MARGIN, y);
    y += introLines.length * 4.6 + 4;

    // ---- KPI's ----
    var kpiH = 28;
    var gap = 6;
    var kpiW = (CW - gap) / 2;

    // Linker — Besparing (navy)
    doc.setFillColor(NAVY[0], NAVY[1], NAVY[2]);
    doc.roundedRect(MARGIN, y, kpiW, kpiH, 3, 3, 'F');
    doc.setTextColor(GOLD_LT[0], GOLD_LT[1], GOLD_LT[2]);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(7.5);
    doc.text('NETTO VOORDEEL PER JAAR', MARGIN + 7, y + 8);
    doc.setTextColor(WHITE[0], WHITE[1], WHITE[2]);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(22);
    doc.text(fmtEUR(r.net), MARGIN + 7, y + 19);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(7.5);
    doc.setTextColor(CREAM[0], CREAM[1], CREAM[2]);
    doc.text('Na aftrek van het Guided-abonnement', MARGIN + 7, y + 24);

    // Rechter — Tijdswinst (cream met border)
    var rx = MARGIN + kpiW + gap;
    doc.setFillColor(CREAM[0], CREAM[1], CREAM[2]);
    doc.setDrawColor(BORDER[0], BORDER[1], BORDER[2]);
    doc.setLineWidth(0.4);
    doc.roundedRect(rx, y, kpiW, kpiH, 3, 3, 'FD');
    doc.setTextColor(GOLD[0], GOLD[1], GOLD[2]);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(7.5);
    doc.text('TIJDSWINST HR', rx + 7, y + 8);
    doc.setTextColor(NAVY[0], NAVY[1], NAVY[2]);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(22);
    doc.text(r.hours + ' uur', rx + 7, y + 19);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(7.5);
    doc.setTextColor(BODY[0], BODY[1], BODY[2]);
    doc.text('Vrijgespeelde HR-capaciteit', rx + 7, y + 24);

    y += kpiH + 6;

    // ---- Opbouw van het bedrag (bruto, abonnement, netto, terugverdientijd) ----
    var rows = [
      ['Bruto HR-besparing per jaar', fmtEUR(r.gross)],
      ['Guided-abonnement, tijdelijk € ' + LICENSE_MONTH + ' p/m, excl. btw', '- ' + fmtEUR(r.license)],
      ['Netto voordeel per jaar', fmtEUR(r.net)],
      ['Terugverdientijd', r.paybackMonths ? ('± ' + r.paybackMonths + (r.paybackMonths === 1 ? ' maand' : ' maanden')) : 'niet op HR-tijd alleen']
    ];
    var rowH = 5.6;
    var boxH = rows.length * rowH + 5;
    doc.setFillColor(CREAM[0], CREAM[1], CREAM[2]);
    doc.setDrawColor(BORDER[0], BORDER[1], BORDER[2]);
    doc.setLineWidth(0.4);
    doc.roundedRect(MARGIN, y, CW, boxH, 3, 3, 'FD');
    var ry = y + 6;
    rows.forEach(function (row, i) {
      var isNet = (i === 2);
      doc.setFont('helvetica', isNet ? 'bold' : 'normal');
      doc.setFontSize(8.5);
      doc.setTextColor(isNet ? NAVY[0] : BODY[0], isNet ? NAVY[1] : BODY[1], isNet ? NAVY[2] : BODY[2]);
      doc.text(row[0], MARGIN + 6, ry);
      doc.text(row[1], W - MARGIN - 6, ry, { align: 'right' });
      if (i < rows.length - 1) {
        doc.setDrawColor(BORDER[0], BORDER[1], BORDER[2]);
        doc.setLineWidth(0.2);
        doc.line(MARGIN + 6, ry + 1.8, W - MARGIN - 6, ry + 1.8);
      }
      ry += rowH;
    });
    if (!r.paybackMonths) {
      y += boxH + 3;
      doc.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      doc.setFont('helvetica', 'italic');
      doc.setFontSize(8);
      var bePlain = doc.splitTextToSize(
        'Bij deze omvang zit de waarde vooral in gemak, consistentie en nooit meer een moment vergeten, minder in kostenbesparing.',
        CW
      );
      doc.text(bePlain, MARGIN, y + 1);
      y += bePlain.length * 3.8 + 4;
    } else {
      y += boxH + 7;
    }

    // ---- "De indicatie is gebaseerd op:" ----
    doc.setTextColor(GOLD[0], GOLD[1], GOLD[2]);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(7.5);
    doc.text('DE INDICATIE IS GEBASEERD OP', MARGIN, y);
    y += 5.5;

    var basis = [
      'aantal medewerkers',
      'gemiddelde HR-kosten',
      'aantal waarderingsmomenten',
      'gemiddelde tijdsbesteding rondom waardering',
      'Guided-abonnement van € ' + LICENSE_MONTH + ' per maand (tijdelijk tarief)'
    ];
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9.5);
    doc.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
    basis.forEach(function (item) {
      doc.setFillColor(GOLD[0], GOLD[1], GOLD[2]);
      doc.circle(MARGIN + 1.5, y - 1.3, 0.8, 'F');
      doc.text(item, MARGIN + 5, y);
      y += 5;
    });
    y += 1;

    doc.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
    doc.setFont('helvetica', 'italic');
    doc.setFontSize(8.5);
    var detailLines = doc.splitTextToSize(
      'In een uitgebreide berekening maken we onderscheid tussen individuele en collectieve momenten.',
      CW
    );
    doc.text(detailLines, MARGIN, y);
    y += detailLines.length * 4 + 6;

    // ---- Hoe Secret Gifters helpt (navy CTA) ----
    var helpsH = 26;
    doc.setFillColor(NAVY[0], NAVY[1], NAVY[2]);
    doc.roundedRect(MARGIN, y, CW, helpsH, 3, 3, 'F');

    doc.setTextColor(GOLD_LT[0], GOLD_LT[1], GOLD_LT[2]);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(7.5);
    doc.text('HOE SECRET GIFTERS HELPT', MARGIN + 8, y + 8);

    doc.setTextColor(WHITE[0], WHITE[1], WHITE[2]);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9.5);
    var helpsLines = doc.splitTextToSize(
      'Secret Gifters helpt organisaties om waardering structureel, persoonlijk en schaalbaar te organiseren — zonder extra regelwerk voor HR of management.',
      CW - 16
    );
    doc.text(helpsLines, MARGIN + 8, y + 14);

    drawFooter(doc, W, MARGIN, 1, 2);

    // ============================================================
    // PAGINA 2 — Onderschattingen + Jullie antwoorden
    // ============================================================
    doc.addPage();
    doc.setFillColor(WHITE[0], WHITE[1], WHITE[2]);
    doc.rect(0, 0, W, H, 'F');

    // Slankere navy header op pagina 2
    var headerH2 = 20;
    doc.setFillColor(NAVY[0], NAVY[1], NAVY[2]);
    doc.rect(0, 0, W, headerH2, 'F');

    doc.setTextColor(GOLD_LT[0], GOLD_LT[1], GOLD_LT[2]);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(8);
    doc.text('SECRET GIFTERS', MARGIN, 12);

    doc.setTextColor(WHITE[0], WHITE[1], WHITE[2]);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8.5);
    doc.text(company ? company : 'Rapportage detail', W - MARGIN, 12, { align: 'right' });

    doc.setFillColor(GOLD[0], GOLD[1], GOLD[2]);
    doc.rect(0, headerH2, W, 0.5, 'F');

    y = 32;

    // ---- Wat organisaties vaak onderschatten ----
    doc.setTextColor(NAVY[0], NAVY[1], NAVY[2]);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(13);
    doc.text('Wat organisaties vaak onderschatten', MARGIN, y);
    y += 4;

    doc.setDrawColor(BORDER[0], BORDER[1], BORDER[2]);
    doc.setLineWidth(0.3);
    doc.line(MARGIN, y, W - MARGIN, y);
    y += 6;

    var underestimate = [
      ['Tijd voor coördinatie en opvolging',
       'Plannen, kiezen, bestellen en versturen vraagt meer tijd dan vaak wordt gedacht.'],
      ['Ad hoc aanvragen',
       'Last-minute verzoeken doorbreken de planning en vragen om snelle beslissingen.'],
      ['Inspiratie en afstemming',
       'Steeds opnieuw bedenken wat past bij de ontvanger kost mentale energie.'],
      ['Inconsistentie in waardering',
       'De ene collega ontvangt meer of vaker aandacht dan de ander.'],
      ['Afhankelijkheid van één persoon',
       'Bij afwezigheid loopt het hele waarderingsproces vast.']
    ];

    doc.setFont('helvetica', 'normal');
    underestimate.forEach(function (row) {
      doc.setFillColor(GOLD[0], GOLD[1], GOLD[2]);
      doc.circle(MARGIN + 1.5, y + 0.3, 0.9, 'F');

      doc.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(10);
      doc.text(row[0], MARGIN + 5, y + 1);

      doc.setTextColor(BODY[0], BODY[1], BODY[2]);
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(9);
      var descLines = doc.splitTextToSize(row[1], CW - 5);
      doc.text(descLines, MARGIN + 5, y + 5.5);

      y += 5.5 + descLines.length * 4 + 3.5;
    });

    y += 3;

    // ---- Jullie antwoorden ----
    doc.setTextColor(NAVY[0], NAVY[1], NAVY[2]);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(13);
    doc.text('Jullie antwoorden', MARGIN, y);
    y += 4;

    doc.setDrawColor(BORDER[0], BORDER[1], BORDER[2]);
    doc.setLineWidth(0.3);
    doc.line(MARGIN, y, W - MARGIN, y);
    y += 5;

    var items = [
      {
        q: 'Hoeveel medewerkers hebben jullie?',
        a: state.employees + (state.employees === 1 ? ' medewerker' : ' medewerkers')
      },
      {
        q: 'Wat zijn de gemiddelde HR-kosten per uur?',
        a: fmtEUR(state.hrRate) + ' per uur'
      },
      {
        q: 'Hoe vaak ontvangen medewerkers per jaar een attentie?',
        a: state.frequency + (state.frequency === 1 ? ' moment' : ' momenten') + ' per medewerker'
      },
      {
        q: 'Op welke momenten geven jullie aandacht of een attentie?',
        a: listMoments(state)
      },
      {
        q: 'Waar lopen jullie het meest tegenaan rondom waardering?',
        a: listChallenges(state)
      },
      {
        q: 'Welke rol past het beste bij jou?',
        a: showRole(state)
      }
    ];

    var rowGap = 4;
    items.forEach(function (it, i) {
      doc.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(8.5);
      doc.text((i + 1) + '.  ' + it.q, MARGIN, y);

      doc.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(10);
      var aLines = doc.splitTextToSize(it.a, CW);
      if (aLines.length > 2) aLines = [aLines[0], aLines[1]];
      doc.text(aLines, MARGIN, y + 5.5);

      var rowH = 5.5 + (aLines.length * 4.4) + rowGap;
      y += rowH;

      if (i < items.length - 1) {
        doc.setDrawColor(BORDER[0], BORDER[1], BORDER[2]);
        doc.setLineWidth(0.2);
        doc.line(MARGIN, y - rowGap + 1, W - MARGIN, y - rowGap + 1);
      }
    });

    drawFooter(doc, W, MARGIN, 2, 2);

    // ============================================================
    // OUTPUT
    // ============================================================
    var safeName = (state.contact.company || 'Rapport').replace(/[^a-zA-Z0-9]+/g, '-').replace(/^-|-$/g, '');
    var filename = 'Secret-Gifters-Rapportage-' + safeName + '.pdf';

    var dataUri = '';
    var base64 = '';
    try {
      dataUri = doc.output('datauristring');
      var commaIdx = dataUri.indexOf('base64,');
      base64 = commaIdx !== -1 ? dataUri.substring(commaIdx + 7) : '';
    } catch (e) { /* niet kritiek */ }

    if (save) {
      doc.save(filename);
      try {
        var blobUrl = doc.output('bloburl');
        window.open(blobUrl, '_blank');
      } catch (e) { /* fallback: alleen download */ }
    }

    var result = { filename: filename, dataUri: dataUri, base64: base64 };
    window.SG_LAST_PDF = result;
    return result;
  }

  // Publieke "stille" build (zonder downloaden)
  window.sgBuildPDF = function (state) {
    return buildPDF(state, false);
  };

  // ============================================================
  // Override van downloadFinalReport
  // ============================================================
  function install() {
    window.downloadFinalReport = function () {
      var btn = document.getElementById('download-btn');
      var orig = btn ? btn.innerHTML : '';
      if (btn) { btn.innerHTML = 'Bezig met genereren...'; btn.disabled = true; }
      try {
        var state = window.SG_CALC_STATE;
        if (!state) {
          alert('Berekenstatus niet gevonden — vernieuw de pagina en probeer opnieuw.');
          return;
        }
        buildPDF(state, true);
      } catch (err) {
        console.error('SG PDF error:', err);
        alert('Er ging iets mis bij het genereren van de PDF: ' + (err && err.message ? err.message : err));
      } finally {
        if (btn) { btn.innerHTML = orig; btn.disabled = false; }
      }
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', install);
  } else {
    install();
  }
})();
